<!--
 * @Description: 跳转页面选择弹窗（站内链接/站外链接/跳转小程序），支持点位链路与数据源初始化参数
 * @Autor: WangYuan
 * @Date: 2021-08-12 17:23:08
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-08-31 20:12:08
-->
<template>
  <el-dialog
    append-to-body
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    title="请选择跳转页面"
    width="1000px"
    :before-close="handleClose"
  >
    <div class="list mb30">
      <div
        v-for="(tab, i) in list"
        :key="i"
        :class="[value.type == tab.type ? 'tab-active' : '']"
        class="tab flex-center"
        @click="changeTab(tab.type)"
      >
        {{ tab.label }}
      </div>
    </div>

    <!-- 站内链接 -->
    <template v-if="value.type == 'insid'">
      <div class="pageContent">
        <!--左侧：页面列表-->
        <div class="left" style="height: 510px; overflow-x: scroll">
          <div
            v-for="(item, index) in dataList"
            :key="index"
            :class="curClickPage.pagesId == item.pagesId ? 'cur' : 'nor'"
            @click="getPoints(item, false)"
          >
            {{ item.name }}
          </div>
        </div>

        <!--右侧：点位 + 数据源初始化参数-->
        <div class="right">
          <div v-if="curClickPage.linkPoints || curClickPage.dsInitParams">
            <!--一级点位-->
            <div class="points" v-if="curClickPage.linkPoints">
              <div class="points-tit">
                选择
                <span v-if="pointsConfig && pointsConfig.title">
                  {{ pointsConfig.title }}
                </span>
              </div>
              <div class="points-cates">
                <span
                  v-for="(item, index) in pointsList"
                  :key="index"
                  :class="
                    curPoint.value == item.value ? 'cate curCate' : 'cate'
                  "
                  @click="btnPoint(item)"
                >
                  {{ item[showName] }}
                </span>
              </div>
            </div>

            <!--树形点位：二级-->
            <div
              class="points-cates"
              v-if="
                curPoint.value &&
                pointsConfig &&
                pointsConfig.showLevel &&
                pointsConfig.showLevel != 1 &&
                curPoint.children &&
                curPoint.children.length > 0
              "
            >
              <p style="margin-bottom: 15px">
                选择"{{ curPoint[showName] }}"的子级
              </p>
              <span
                v-for="(item, index) in curPoint.children"
                :key="index"
                :class="
                  curSecondPoint.value == item[clickId]
                    ? 'cate curCate'
                    : 'cate'
                "
                @click="btnPointSecondTree(item, pointsConfig.children)"
              >
                {{ item[showName] }}
              </span>
            </div>

            <!--树形点位：三级-->
            <div
              class="points-cates"
              v-if="
                curSecondPoint.value &&
                pointsConfig &&
                pointsConfig.showLevel == 3 &&
                curSecondPoint.children &&
                curSecondPoint.children.length > 0
              "
            >
              <p style="margin-bottom: 15px">
                选择"{{ curSecondPoint[showName] }}"的子级
              </p>

              <span
                v-for="(item, index) in curSecondPoint.children"
                :key="index"
                :class="
                  curThreePoint.value == item[clickId] ? 'cate curCate' : 'cate'
                "
                @click="btnPointThreeTree(item, pointsConfig.children)"
              >
                {{ item[showName] }}
              </span>
            </div>

            <!--二级导航选择项-->
            <div
              class="points-cates"
              v-if="curPoint.value && getSecondeList.length > 0"
            >
              <p style="margin-bottom: 15px">二级导航选择项</p>
              <span
                v-for="(item, index) in getSecondeList"
                :key="index"
                :class="tableSecondIndex == index ? 'cate curCate' : 'cate'"
                @click="btnPointSecond(item, index)"
              >
                {{ item.name }}
              </span>
            </div>

            <!--数据源初始化参数-->
            <div v-if="curClickPage.dsInitParams && dsInitParams.length > 0">
              <el-tabs type="border-card">
                <el-tab-pane
                  :label="item.title"
                  v-for="(item, index) in dsInitParams"
                  :key="index"
                >
                  <div class="points-tit">
                    选择{{ item.title ? item.title : "" }}({{
                      item.required ? "必填" : "非必填"
                    }})
                  </div>

                  <!--树形数据源-->
                  <div
                    v-if="
                      item.showType == 'show_tree' &&
                      item.dataList.length > 0 &&
                      item.dataMapper
                    "
                  >
                    <el-tree
                      :key="'tree-' + index + '-' + dialogVisible"
                      ref="tree"
                      :data="item.dataList"
                      show-checkbox
                      check-strictly
                      check-on-click-node
                      default-expand-all
                      :node-key="item.relationField"
                      highlight-current
                      :props="{
                        children:
                          item.dataMapper?.children?.source || 'children',
                        label: 'name',
                      }"
                      @check="
                        (node, checkedNode) =>
                          handleCheckChange(
                            node,
                            checkedNode,
                            item.relationField,
                            index,
                            item.params,
                          )
                      "
                    >
                    </el-tree>
                  </div>

                  <!--表格数据源-->
                  <div v-else>
                    <el-table
                      ref="insidTable"
                      :data="item.dataList"
                      class="insidTab"
                      size="mini"
                      stripe
                      max-height="500"
                      :show-header="false"
                    >
                      <el-table-column
                        align="center"
                        type="selection"
                        width="55"
                      >
                        <template slot-scope="scope">
                          <input
                            type="checkBox"
                            :checked="
                              scope.row[item.relationField] == item.curChoose
                            "
                            @click="
                              btnClickParams(
                                index,
                                scope.row[item.relationField],
                              )
                            "
                          />
                        </template>
                      </el-table-column>

                      <!--dataMapper 缺失时兜底展示名称列，避免表格只剩勾选框-->
                      <el-table-column
                        v-if="!item.dataMapper || item.dataMapper.length === 0"
                        label="名称"
                        prop="name"
                        class-name="custom-cell"
                      >
                      </el-table-column>

                      <el-table-column
                        :label="items.targetName"
                        :prop="items.source"
                        class-name="custom-cell"
                        v-for="(items, indexs) in item.dataMapper"
                        :key="indexs"
                      >
                      </el-table-column>
                    </el-table>

                    <el-pagination
                      @size-change="handleSizeChange(index, item, $event)"
                      @current-change="handleCurrentChange(index, item, $event)"
                      :current-page="item.current"
                      :page-size="item.size"
                      :pager-count="5"
                      :page-sizes="[10, 20, 50, 100, 200]"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="item.total"
                      v-if="item.needPage == 1"
                      background
                      class="pagina mt15"
                    ></el-pagination>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- 站外链接 -->
    <template v-if="value.type == 'link'">
      <el-form ref="form" :model="value" label-width="80px">
        <el-form-item label="跳转方式" prop="mode">
          <el-radio-group v-model="value.mode">
            <el-radio label="1">H5跳转</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" prop="mode">
          <el-input
            v-model="value.id"
            placeholder="请输入h5跳转链接"
            size="mini"
            style="width: 250px"
          ></el-input>
        </el-form-item>
      </el-form>
    </template>

    <!-- 跳转小程序 -->
    <template v-if="value.type == 'applet'">
      <el-form ref="form" :model="value" label-width="80px">
        <el-form-item label="跳转方式:" prop="mode">
          <el-radio-group v-model="value.mode">
            <el-radio label="1">常规跳转</el-radio>
            <el-radio label="2">微信半屏小程序</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="App ID:" prop="mode">
          <el-input
            v-model="value.id"
            @input="bindInput($event, 'appId')"
            placeholder="请输入小程序APPID"
            size="mini"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item label="路径:" prop="mode">
          <el-input
            :value="value.data.jump"
            @input="bindInput($event, 'path')"
            placeholder="请输入跳转链接"
            size="mini"
            style="width: 250px"
          ></el-input>
        </el-form-item>
      </el-form>
    </template>

    <div slot="footer" class="dialog-footer">
      <el-button @click="bindClose">取 消</el-button>
      <el-button type="primary" @click="bindConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { getFormPage } from "@/api/project";
import {
  getCategoryList,
  datasourcePage,
  getCategoryListPost,
} from "@/api/easyApp";
import { deepClone } from "../../../js/utils";

// 过滤数组中的空项（null/undefined/空字符串/空对象），
// 避免把空值拼进请求参数（如 codes=,,,,）或渲染出无意义的空配置项
function compactList(list) {
  if (!Array.isArray(list)) return [];
  return list.filter(
    (item) =>
      item !== null &&
      item !== undefined &&
      String(item).trim() !== "" &&
      !(typeof item === "object" && Object.keys(item).length === 0),
  );
}

// 安全解析 JSON，非法/空值时返回兜底值，避免弹窗白屏
function safeParse(json, fallback) {
  if (json === null || json === undefined || json === "") return fallback;
  try {
    const result = JSON.parse(json);
    return result === null || result === undefined ? fallback : result;
  } catch (e) {
    console.error("JSON 解析失败:", e, json);
    return fallback;
  }
}

export default {
  name: "JumpDialogView",
  // inject: ["value"],
  data() {
    return {
      lastCheckedNode: null,
      list: [
        { label: "站内链接", type: "insid" },
        { label: "站外链接", type: "link" },
        { label: "跳转小程序", type: "applet" },
        { label: "不跳转", type: undefined },
      ],
      dataList: [],
      totalPage: 0,
      dialogVisible: false,
      dataListLoading: false,
      queryForm: {
        aid: "",
        size: 100,
        current: 1,
      },
      curActive: "", //点击过的点位
      pointsList: [], //点位列表
      curClickPage: {
        pagesId: "",
      },
      clickId: "",
      showName: "",
      curPoint: {
        value: "",
      },
      initData: [],
      dsInitParams: [],

      valueOld: {},
      value: {
        data: {},
        id: "",
        linkPoint: null,
        initParams: [],
        type: "insid",
      },

      linkPointsList: [], //点位链接数组
      secondLinkPointId: "",
      tableSecondIndex: -1,

      curSecondPoint: {
        value: "",
      },
      curThreePoint: {
        value: "",
      },
    };
  },

  props: {
    linkList: {
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(["project", "fixedPages"]),
    customPages() {
      return this.project.pagesEntityList;
    },

    // 当前页面的点位配置（linkPoints 解析结果的第一项），模板与方法统一从这里取
    pointsConfig() {
      return this.linkPointsList[0] || null;
    },

    //根据当前一级点位 value 查找对应的二级导航配置
    //纯查找逻辑（无副作用），computed 与 secondLinkPointId 的同步统一从这里取
    findSecondLinkPoint() {
      //不再用 pointsList[curPoint.value] 隐式依赖 value == 数组下标，改为按 value 匹配
      const curPointItem = this.pointsList.find(
        (p) => p.value == this.curPoint.value,
      );
      if (!curPointItem || !Array.isArray(curPointItem.components)) {
        return { id: "", data: [] };
      }

      let matched = null;
      curPointItem.components.forEach((element) => {
        String(element)
          .split("-")
          .forEach((id) => {
            const lp = this.linkPointsList.find((item2) => item2.id == id);
            //后匹配覆盖先匹配，保持原逻辑（最后一个命中的生效）
            if (lp) matched = lp;
          });
      });
      return matched
        ? { id: matched.id, data: matched.data || [] }
        : { id: "", data: [] };
    },

    //把二级导航点位 id 同步到 data（由事件触发，替代原 computed 内的副作用）
    syncSecondLinkPointId() {
      this.secondLinkPointId = this.findSecondLinkPoint().id;
    },

    getSecondeList() {
      return this.findSecondLinkPoint().data;
    },
  },

  methods: {
    bindInput(val, key) {
      if (key == "appId") {
        this.value.id = val;
      } else {
        // data.jump 可能是新增属性，需要 $set 保证响应式
        this.$set(this.value.data, "jump", val);
      }
    },

    //兼容 dataMapper 的两种配置格式：
    //数组：[{ targetName, source }]
    //对象：{ target: { source, sourceName }, paramsData: {...} }（与新标签组件 SchemaTagSourceNew 的解析逻辑对齐）
    normalizeDataMapper(dataMapper) {
      if (Array.isArray(dataMapper)) return dataMapper;
      if (dataMapper && typeof dataMapper === "object") {
        let list = [];
        for (const key in dataMapper) {
          if (key === "paramsData") continue;
          const conf = dataMapper[key] || {};
          list.push({
            target: key,
            targetName: conf.sourceName,
            source: conf.source || key,
          });
        }
        return list;
      }
      return [];
    },

    //恢复 value 到打开弹窗时的旧值，并同步 dsInitParams 的勾选状态
    restoreOldValue() {
      if (!this.valueOld) return;
      this.value = deepClone(this.valueOld);
      if (this.dsInitParams && this.value.initParams) {
        this.dsInitParams.forEach((item) => {
          item.curChoose = "";
        });
        this.value.initParams.forEach((initParam) => {
          const index = this.matchParamIndex(this.dsInitParams, initParam);
          if (index != -1) {
            const relationField = initParam["relationField"];
            this.dsInitParams[index].curChoose = initParam[relationField] || "";
          }
        });
      }
    },

    //点击右上角 X 关闭：视为取消，恢复旧值
    handleClose(done) {
      this.restoreOldValue();
      done();
    },

    btnChoose(item) {
      this.curActive = item.value;
    },

    //获取点位列表
    async getPoints(item, init) {
      //初始化的时候不用处理东西
      if (!init) {
        let index = -1;
        if (this.value.id) {
          index = this.value.id.indexOf(item.pagesId);
        }
        if (index !== -1) {
          this.value.data = {};
          this.value.id = "";
        } else {
          this.value.data = {
            aid: item.aid,
            home: item.home,
            name: item.name,
            pagesId: item.pagesId,
            sign: item.sign,
          };
          this.value.id = item.pagesId;
        }
        this.tableSecondIndex = -1;

        this.value.linkPoint = null;
        this.value.initParams = [];
        this.curPoint = { value: "" };
        this.curSecondPoint = { value: "" };
        this.curThreePoint = { value: "" };
        this.secondLinkPointId = "";
      }

      this.curClickPage = item;
      this.linkPointsList = safeParse(item.linkPoints, []);

      const pointConfig = this.pointsConfig;

      if (pointConfig) {
        this.clickId = pointConfig.sign;
        this.showName = pointConfig.name;

        if (pointConfig.type == "remote") {
          let data = {
            url:
              pointConfig.url == "/form/category/condition/tree" ||
              pointConfig.url == "form/category/condition/tree"
                ? "/form/category/condition/tree?type=1"
                : pointConfig.url,
          };

          let res = await getCategoryList(data);
          let list = [];
          for (const i in res.data) {
            let obj = {
              sign: this.clickId,
              value: res.data[i][this.clickId],
              name: res.data[i][this.showName],
            };
            if (
              pointConfig.showLevel &&
              (pointConfig.showLevel == 2 || pointConfig.showLevel == 3)
            ) {
              obj["children"] = res.data[i][pointConfig.children];
            }
            list.push(obj);
          }
          if (pointConfig.groupModel) {
            list.unshift({
              sign: this.clickId,
              value: "123456",
              name: "全部",
              children: [],
            });
          }
          this.pointsList = list;
        } else {
          this.pointsList = pointConfig.data || [];
        }

        //初始化时回显已保存的点位
        if (init && this.value.linkPoint) {
          this.curPoint = deepClone(this.value.linkPoint);

          if (this.curPoint.secondTreeLinkPoint) {
            let index = this.pointsList.findIndex(
              (p) => p.value == this.curPoint.value,
            );
            if (index != -1) {
              this.curSecondPoint = deepClone(
                this.curPoint.secondTreeLinkPoint,
              );
              this.curPoint["children"] = deepClone(
                this.pointsList[index].children,
              );

              if (
                this.curPoint.threeTreeLinkPoint &&
                this.curPoint["children"]
              ) {
                let secondIndex = this.curPoint["children"].findIndex(
                  (p) => p[this.clickId] == this.curSecondPoint.value,
                );

                let children = pointConfig.children;
                if (secondIndex != -1) {
                  this.curSecondPoint["children"] =
                    this.curPoint["children"][secondIndex][children];
                  this.curThreePoint = deepClone(
                    this.curPoint.threeTreeLinkPoint,
                  );
                }
              }
            }
          }

          if (this.value.linkPoint && this.value.linkPoint.secondLinkPoint) {
            this.tableSecondIndex = Number(
              this.value.linkPoint.secondLinkPoint.value,
            );
            this.secondLinkPointId = this.value.linkPoint.secondLinkPoint.id;
          }
        }
      } else {
        this.pointsList = [];
      }

      //得到初始化参数 获取数据
      if (item.dsInitParams) {
        let dsInitParams = safeParse(item.dsInitParams, []);

        let code = [];
        let initList = [];
        let initDictList = [];

        for (const i in dsInitParams) {
          //解析后排空：过滤 null/空对象等无效配置项，避免下游 filter 出空参数
          dsInitParams[i].relationParams = compactList(
            safeParse(dsInitParams[i].relationParams, []),
          );

          //字典参数：useDictDs 为 true 或 paramType 为 dict
          let dict = dsInitParams[i].relationParams.filter(
            (p) =>
              (p.useDictDs && p.useDictDs == true) ||
              (p.paramType && p.paramType == "dict"),
          );

          //普通参数 = 字典参数的补集（useDictDs 为 false/缺省 且 paramType 非 dict）
          //注意：不能写成 (useDictDs && useDictDs != true) || (paramType && paramType != 'dict')，
          //否则 useDictDs=false 且未配 paramType 的普通参数会被两组过滤器同时漏掉，页面右侧只渲染空 tabs
          let normalParams = dsInitParams[i].relationParams.filter(
            (p) =>
              !(p.useDictDs && p.useDictDs == true) &&
              !(p.paramType && p.paramType == "dict"),
          );

          for (const j in normalParams) {
            const dsCode =
              normalParams[j]["dsName"] || normalParams[j]["relationDS"];
            //排空：未配置数据源编码的参数无法加载数据，直接跳过，避免渲染出空 tab
            if (!dsCode || String(dsCode).trim() === "") {
              console.warn(
                `[JumpDialog] 参数 ${normalParams[j]["name"] || ""} 未配置数据源编码(dsName/relationDS)，已跳过`,
              );
              continue;
            }
            code.push(String(dsCode).trim());

            const dataMapperIndex = this.linkList.findIndex(
              (link) =>
                link.code == normalParams[j]["dsName"] ||
                link.code == normalParams[j]["relationDS"],
            );

            let dataMapper = [];
            if (dataMapperIndex != -1) {
              const configContent =
                this.linkList[dataMapperIndex].dataMapperList?.[0]?.[
                  "configContent"
                ];
              dataMapper = this.normalizeDataMapper(
                safeParse(configContent, []),
              );
            } else {
              console.warn(
                `[JumpDialog] linkList 中未找到数据源 ${dsCode}，表格将按默认名称列展示。请检查该数据源是否配置了 linkList 标签`,
              );
            }

            initList.push({
              code: dsCode,
              componentId: dsInitParams[i].componentId,
              componentIdCode: dsInitParams[i].componentId + "*" + dsCode,
              dataMapper: dataMapper,
              name: normalParams[j]["name"], //传递的
              relationField: normalParams[j]["dsField"]
                ? normalParams[j]["dsField"]
                : normalParams[j]["relationField"], //勾选的
              required: normalParams[j].required,
              current: 1,
              size: 10,
              dataList: [],
              pages: 0,
              total: 0,
              curChoose: "",
              url: "",
              title: "",
              needPage: 0,
            });
          }

          for (const j in dict) {
            initDictList.push({
              code: "",
              componentId:
                dsInitParams[i].componentId + "*dict" + initDictList.length,
              componentIdCode: "",
              dataMapper: {
                label: {
                  source: "label",
                  sourceName: dict[j].dictDs.name,
                },
              },
              name: dict[j].name,
              relationField: "value",
              required: dict[j].required,
              current: 1,
              size: 10,
              dataList: safeParse(dict[j].dictDs.items, []),
              pages: 0,
              total: 0,
              curChoose: "",
              url: "",
              title: dict[j].dictDs.name,
              needPage: 0,
            });
          }
        }

        //拉取数据源元数据，按 code 匹配（避免按下标对齐导致错位）
        //传参前排空 + 去重，避免拼出 codes=,,,, 之类的脏参数
        const validCodes = [...new Set(compactList(code))];
        if (validCodes.length > 0) {
          let res = await datasourcePage({
            codes: validCodes.toString(),
            current: 1,
            size: 100,
          });
          let records = res.data.records || [];

          const recordsByCode = {};
          records.forEach((r) => {
            recordsByCode[r.code] = r;
          });

          for (const i in initList) {
            const record = recordsByCode[initList[i].code];
            if (!record) continue;

            let query = {
              current: 1,
              size: 10,
              dataList: [],
              pages: 0,
              code: initList[i].code,
              total: 0,
            };

            let result = await this.getInitData(
              query,
              record.url,
              record.method,
            );
            if (result == null) continue;

            initList[i].needPage = record.needPage;
            initList[i].showType = record.showType;
            if (record.params) {
              // 兼容 params 配置多个的情况：完整保存数组，使用处逐项判断
              //解析后排空：过滤空项，避免下游 multiValue 判断拿到空配置
              initList[i].params = compactList(safeParse(record.params, []));
            }

            if (record.needPage == 1) {
              initList[i].dataList = result.records || [];
              initList[i].pages = result.pages;
              initList[i].total = result.total;
            } else {
              initList[i].dataList = result;
            }

            initList[i].url = record.url;
            initList[i].title = record.name;
            initList[i].method = record.method;
          }
        }

        //排空：未匹配到数据源元数据（title/url 为空）的条目不渲染，
        //否则顶部会出现无标题的空 tab（勾选框 + 暂无数据）
        initList = initList.filter((item) => item.title && item.url);

        this.dsInitParams = [...initDictList, ...initList].filter(
          (item) => item.title,
        );

        //初始化时回显已保存的参数勾选状态
        if (init && this.value.initParams) {
          for (const i in this.value.initParams) {
            const initParam = this.value.initParams[i];
            let index = this.matchParamIndex(this.dsInitParams, initParam);
            if (index != -1) {
              const relationField = initParam["relationField"];
              this.dsInitParams[index].curChoose = initParam[relationField];
            }
          }
        }
      } else {
        this.dsInitParams = [];
      }

      //树形初始化选中
      if (this.value.initParams && this.value.initParams.length > 0) {
        this.value.initParams.forEach((initParam) => {
          let index = this.matchParamIndex(this.dsInitParams, initParam);
          if (
            index > -1 &&
            this.dsInitParams[index].showType == "show_tree" &&
            initParam[this.dsInitParams[index].relationField]
          ) {
            let idList =
              initParam[this.dsInitParams[index].relationField].split(",");
            this.$nextTick(() => {
              if (this.$refs.tree && this.$refs.tree[index]) {
                this.$refs.tree[index].setCheckedKeys(idList);
              }
            });
          }
        });
      } else {
        // 如果没有选中项，清除所有树形勾选状态
        this.$nextTick(() => {
          if (this.$refs.tree && Array.isArray(this.$refs.tree)) {
            this.$refs.tree.forEach((tree) => {
              if (tree) {
                tree.setCheckedKeys([]);
              }
            });
          }
        });
      }
    },

    matchParamIndex(dsInitParams, initParam) {
      return dsInitParams.findIndex(
        (item) =>
          item.componentIdCode == initParam.componentIdCode ||
          item.componentId == initParam.componentId,
      );
    },

    //拉取数据源数据，method 缺省时按 GET 处理
    async getInitData(obj, url, method) {
      const m = (method || "get").toUpperCase();
      if (m !== "POST" && m !== "GET") return null;

      let data = {
        current: obj.current,
        size: obj.size,
        url:
          url == "/form/category/condition/tree" ||
          url == "form/category/condition/tree"
            ? "/form/category/condition/tree?type=1"
            : url,
      };

      let res =
        m === "POST"
          ? await getCategoryListPost(data)
          : await getCategoryList(data);
      return res.data;
    },

    //点击点位跳转
    btnPoint(item) {
      this.tableSecondIndex = -1;
      if (this.curPoint && this.curPoint.value == item.value) {
        this.curPoint = { value: "" };
        this.curSecondPoint = { value: "" };
        this.curThreePoint = { value: "" };
        this.value.linkPoint = null;
      } else {
        this.curPoint = item;
        this.value.linkPoint = {
          sign: item.sign,
          value: item.value,
          name: item.name,
          id: this.pointsConfig ? this.pointsConfig["id"] : "",
          slot: item.slot || "",
          cvalue: item.cvalue || "",
        };

        this.curSecondPoint = { value: "" };
        this.value.linkPoint.secondTreeLinkPoint = {};
        this.curThreePoint = { value: "" };
        this.value.linkPoint.threeTreeLinkPoint = {};
      }

      //一级点位变化后同步二级导航点位 id（原来在 getSecondeList computed 内改，时序不可控）
      this.syncSecondLinkPointId();
    },

    //点击二级导航点位
    btnPointSecond(item, index) {
      if (!this.value.linkPoint) return;
      if (this.tableSecondIndex == index) {
        this.tableSecondIndex = -1;
        this.value.linkPoint.secondLinkPoint = {};
      } else {
        this.tableSecondIndex = index;
        this.value.linkPoint.secondLinkPoint = item;
        this.value.linkPoint.secondLinkPoint.id = this.secondLinkPointId;
      }
    },

    //点击树形二级导航点位
    btnPointSecondTree(item, childrenSign) {
      if (!this.value.linkPoint) return;
      if (
        this.curSecondPoint &&
        this.curSecondPoint.value == item[this.clickId]
      ) {
        this.curSecondPoint = { value: "" };
        this.value.linkPoint.secondTreeLinkPoint = {};
        this.curThreePoint = { value: "" };
        this.value.linkPoint.threeTreeLinkPoint = {};
      } else {
        this.curSecondPoint = {
          value: item[this.clickId],
          name: item[this.showName],
          children: item[childrenSign] ? item[childrenSign] : [],
        };

        this.curThreePoint = { value: "" };
        this.value.linkPoint.threeTreeLinkPoint = {};

        this.value.linkPoint.secondTreeLinkPoint = {
          sign: this.clickId,
          value: item[this.clickId],
          name: item[this.showName],
          id: this.pointsConfig ? this.pointsConfig["id"] : "",
        };
      }
    },

    //点击树形三级导航点位
    btnPointThreeTree(item, childrenSign) {
      if (!this.value.linkPoint) return;
      if (
        this.curThreePoint &&
        this.curThreePoint.value == item[this.clickId]
      ) {
        this.curThreePoint = { value: "" };
        this.value.linkPoint.threeTreeLinkPoint = {};
      } else {
        this.curThreePoint = {
          value: item[this.clickId],
          name: item[this.showName],
          children: item[childrenSign],
        };

        this.value.linkPoint.threeTreeLinkPoint = {
          sign: this.clickId,
          value: item[this.clickId],
          name: item[this.showName],
          id: this.pointsConfig ? this.pointsConfig["id"] : "",
        };
      }
    },

    //点击树节点
    handleCheckChange(data, checkedNode, relationField, index, params) {
      //多选
      if (params && params.multiValue) {
        let id = checkedNode.checkedKeys.join(",");
        this.btnClickParams(index, id);
      } else {
        //单选：check-on-click-node 已经切换过勾选状态，这里用 checkedNode 判断
        //checkedNode.checkedKeys 反映切换后的状态
        const isChecked = checkedNode.checkedKeys.includes(data[relationField]);
        if (isChecked) {
          // 刚被勾选 → 单选模式只保留这一个
          if (this.$refs.tree && this.$refs.tree[index]) {
            this.$refs.tree[index].setCheckedKeys([data[relationField]]);
          }
          this.btnClickParams(index, data[relationField]);
        } else {
          // 刚被取消勾选
          if (this.$refs.tree && this.$refs.tree[index]) {
            this.$refs.tree[index].setCheckedKeys([]);
          }
          this.btnClickParams(index, "");
        }
      }
    },

    //点击参数
    btnClickParams(index, id) {
      const param = this.dsInitParams[index];
      if (!this.value.initParams) {
        this.value.initParams = [];
      }
      //relationParams 有多个时 componentId 会重复，优先用 componentIdCode 精确匹配
      let index1 = this.value.initParams.findIndex((item) => {
        if (item.componentIdCode && param.componentIdCode) {
          return item.componentIdCode == param.componentIdCode;
        }
        return (
          item.componentId == param.componentId ||
          (item.componentId &&
            item.componentId.indexOf(param.componentId) !== -1)
        );
      });

      // 取消/清空时移除已选项，避免提交空参数
      if (id === "" || id === null || id === undefined) {
        this.dsInitParams[index].curChoose = "";
        if (index1 !== -1) {
          this.value.initParams.splice(index1, 1);
        }
        return;
      }

      this.dsInitParams[index].curChoose = id;
      const relationField = this.dsInitParams[index].relationField;
      const obj = {
        componentId: this.dsInitParams[index].componentId,
        componentIdCode: this.dsInitParams[index].componentIdCode || "",
        relationField: relationField,
        name: this.dsInitParams[index].name,
      };
      obj[relationField] = id;

      if (index1 != -1) {
        //同一字段值相同 → 取消选中
        if (
          obj[relationField] == this.value.initParams[index1][relationField]
        ) {
          this.value.initParams.splice(index1, 1);
        } else {
          //不同值 → 替换
          this.value.initParams.splice(index1, 1, obj);
        }
      } else {
        this.value.initParams.push(obj);
      }
    },

    // 开启
    open(val) {
      this.value = deepClone(val);
      this.value.type = val.type ? val.type : "insid";
      // 后端 Long 在旧数据中可能以数字形式保存，统一转字符串，
      // 避免后续 this.value.id.indexOf(...) 直接抛 TypeError
      this.value.id = this.value.id == null ? "" : String(this.value.id);
      this.valueOld = deepClone(this.value);
      this.dialogVisible = true;
      this.queryForm.current = 1;
      this.getDataList();
    },

    //获取页面列表
    //（init=false 供翻页等场景复用，跳过选中回显/重置逻辑）
    getDataList(init = true) {
      this.queryForm.aid = this.project.aid;
      getFormPage(this.queryForm)
        .then((res) => {
          this.dataList = res.data.records;
          this.totalPage = res.data.total;

          if (!init) return;

          if (this.value && this.value.type == "insid") {
            let index = this.dataList.findIndex(
              (a) => a.pagesId == this.value.id,
            );
            if (index != -1) {
              this.getPoints(this.dataList[index], true);
            } else {
              this.resetSelection();
            }
          } else if (!this.value.type) {
            this.value.type = "insid";
            this.resetSelection();
          }
        })
        .catch((err) => {
          this.$message.error((err && err.msg) || "获取页面列表失败");
        });
    },

    //清空当前选中的页面/点位/参数
    resetSelection() {
      this.value.data = {};
      this.value.id = "";
      this.value.linkPoint = null;
      this.value.initParams = [];
      this.curPoint = { value: "" };
      this.curSecondPoint = { value: "" };
      this.curThreePoint = { value: "" };
    },

    // 取消：不保存，恢复旧值（父组件用旧值覆盖，保证状态一致）
    bindClose() {
      this.restoreOldValue();
      this.$emit("success", this.valueOld);
      this.dialogVisible = false;
    },

    // 切换跳转类型
    changeTab(type) {
      if (this.value.type == type) return;

      this.$set(this.value, "type", type);
      this.$set(this.value, "id", "");
      this.$set(this.value, "data", {});
      this.$set(this.value, "linkPoint", null);
      this.$set(this.value, "initParams", []);

      if (type == "link" || type == "applet") {
        this.$set(this.value, "mode", "1");
      } else {
        this.$set(this.value, "mode", "");
      }

      this.curPoint = { value: "" };
      this.curSecondPoint = { value: "" };
      this.curThreePoint = { value: "" };

      if (type == "insid") {
        this.queryForm.current = 1;
        this.getDataList();
      }
    },

    // 每页数
    handleSizeChange(index, item, val) {
      this.getList(index, item, val, "size");
    },

    // 当前页
    handleCurrentChange(index, item, val) {
      this.getList(index, item, val, "current");
    },

    async getList(index, item, val, cate) {
      if (cate == "size") {
        this.dsInitParams[index].size = val;
        this.dsInitParams[index].current = 1;
      } else {
        this.dsInitParams[index].current = val;
      }

      const m = (item.method || "get").toUpperCase();
      if (m !== "POST" && m !== "GET") return;

      let data = {
        current: this.dsInitParams[index].current,
        size: this.dsInitParams[index].size,
        url:
          item.url == "/form/category/condition/tree" ||
          item.url == "form/category/condition/tree"
            ? "/form/category/condition/tree?type=1"
            : item.url,
      };

      let res =
        m === "POST"
          ? await getCategoryListPost(data)
          : await getCategoryList(data);

      this.dsInitParams[index].dataList =
        m === "GET" ? deepClone(res.data.records) : res.data.records;
      this.dsInitParams[index].pages = res.data.pages;
      this.dsInitParams[index].total = res.data.total;
    },

    // 确定：校验必填参数后提交
    bindConfirm() {
      this.value.data = {
        aid: this.value.data.aid,
        home: this.value.data.home,
        name: this.value.data.name,
        pagesId: this.value.data.pagesId,
        sign: this.value.data.sign,
        jump: this.value.data.jump,
      };

      this.dialogVisible = false;
      this.$emit("success", this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/variable";

.pageContent {
  display: flex;
}

.left {
  width: 160px;
  font-size: 14px;
  border-right: 1px solid #ededed;

  .cur {
    background-color: rgba(239, 250, 255, 1);
    color: rgba(56, 148, 255, 1);
    height: 50px;
    line-height: 50px;
    white-space: nowrap;
    /* 防止文本换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 显示省略符号来代表被修剪的文本 */
    text-indent: 10px;
  }

  .nor {
    height: 50px;
    line-height: 50px;
    color: #333;
    white-space: nowrap;
    /* 防止文本换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 显示省略符号来代表被修剪的文本 */
    text-indent: 10px;
  }
}

.right {
  flex: 1;
  padding-left: 20px;
}

.list {
  display: flex;

  .tab {
    width: 100px;
    height: 30px;
    color: #979797;
    border: solid 1px #ebedf0;
    cursor: pointer;
  }

  .tab-active {
    color: $color-theme;
    border: solid 1px $color-theme;
    background: #e0edff;
  }
}

.first-leve {
  width: 100%;
  height: 33px;
  line-height: 33px;
  padding: 0 20px;
  cursor: pointer;
}

.active {
  color: #ffffff;
  background: rgb(0, 106, 255);
}

.active-Scon {
  color: rgb(56, 148, 255);
  background: rgb(239, 250, 255);
}

::v-deep .insidTab .el-table__header-wrapper .el-table__header .el-checkbox {
  // 找到表头那一行，然后把里面的复选框隐藏掉
  display: none !important;
}

.el-cascader-panel {
  width: 140px !important;
  border: none !important;
}

.el-cascader-menu__list {
  width: 140px !important;
  overflow: hidden;
}

::v-deep .el-cascader-menu {
  min-width: 140px !important;
}

.active {
  color: #fff;
  background: #409fee;
  padding: 3px 5px;
  border-radius: 3px;
  display: inline-block;
}

.normal {
  color: #101010;
  padding: 3px 5px;
  border-radius: 3px;
  margin-right: 10px;
  display: inline-block;
}

.cate {
  background: #f3f4f6;
  font-size: 14px;
  color: #333;
  padding: 10px 20px;
  margin-bottom: 15px;
  margin-right: 15px;
  border-radius: 3px;
  display: inline-block;
}

.curCate {
  color: #fff !important;
  background: #409fee !important;
}

.points-tit {
  margin-bottom: 20px;
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  font-family: PingFangSC-regular;
}

.insidTab .custom-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 20px;
}
</style>
